var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');
var ChipData = require('./chipData.js');

var ChipLedData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    this.baseHeightMax = this.value("baseHeightMax", true);
    this.baseHeightMin = this.value("baseHeightMin", true);

    this.bodyColor = this.value("bodyColor", true);
    this.customBodyColor = this.value("customBodyColor", true);

    //case shape
    this.lensType = this.value("lensType", true);
    this.domeDiameter = this.value("domeDiameter", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.baseHeightMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.baseHeightMin);

    this.nonTransformedSegmentedGeometry.addTrigger(this.customBodyColor);

    this.nonTransformedSegmentedGeometry.addTrigger(this.lensType);
    this.nonTransformedSegmentedGeometry.addTrigger(this.domeDiameter);

    this.nonTransformedSegmentedGeometry.addTrigger(this.bodyColor);
    this.bodyColor(ComponentAttribute.bodyColors.CHIP.LED.Red.value);
};

lib_core.inherit(ChipLedData, DualRowPackageData);
lib_core.JsonParser.registerClass(ChipLedData, "ChipLedData");

module.exports = ChipLedData;

ChipLedData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.colorValidationMap = {};

    this.minMaxPointerMap["baseHeight"] = [this.baseHeightMin, this.baseHeightMax];
    this.validationMap["baseHeightMax"] = [this.baseHeightMax];

    this.colorValidationMap["customBodyColor"] = [this.customBodyColor]; 

    this.validationMap["domeDiameter"] = [this.domeDiameter];    

};

ChipLedData.prototype.getMinMaxFailures = function() {
    var fails = DualRowPackageData.prototype.getMinMaxFailures.call(this);
    for(var key in this.colorValidationMap){
        if(this.colorValidationMap.hasOwnProperty(key)){ 
            //check the entered hex value with a regular expression
            var str = this.colorValidationMap[key][0]();
            var regExp = /^#?[a-fA-F0-9]{3}([a-fA-F0-9]{3})?$/;
            if (!this.bodyColor()){
                if (regExp.test(str) == false){
                    fails.push(this.colorValidationMap[key]);
                }
            } 
        }
    }
   return fails; 
}

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
ChipLedData.prototype.getPads = function(absolutePositions) {
    return ChipData.prototype.getPads.call(this, absolutePositions);
};

ChipLedData.prototype.getSilkscreen = function(pads) {
	var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen(),
        leftPad = pads[0],
        topLineY, bottomLineY,
        pathData;

    var topLineY = leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
    var bottomLineY = leftPad.getPos().y - leftPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;

    var lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance;

    pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLineY), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLineY), PathType.LINE));
    silkscreen.push(pathData);
     
    return silkscreen;
}
